import { render } from "./ClearIcon.vue?vue&type=template&id=0439fca6"
import script from "./ClearIcon.vue?vue&type=script&lang=js"
export * from "./ClearIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__